import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {},
  error: null,
  loading: false,
};

const user = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.data = payload;
    },
  },
});

export const { setUser } = user.actions;
export const getUser = (state) => state.user.data;
export const userReducer = user.reducer;
export default userReducer;
